import {ButtonBase, makeStyles} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';
import {useTranslation} from 'react-i18next';

const useStyles = makeStyles(() => ({
  buttonProgress: {
    color: 'green',
    left: '50%',
    marginLeft: -12,
    marginTop: -12,
    position: 'absolute',
    top: '50%',
  },
}));

interface IProps {
  loading: boolean;
  classColor: string;
  translate?: {
    init: string;
    loading: string;
  };
  customClasses?: string;
}

const ButtonSubmit: React.FC<IProps> = ({
  loading,
  translate,
  classColor,
  customClasses,
}) => {
  const {t} = useTranslation();
  const classes = useStyles();
  translate = Object.assign(
    {
      init: t('botoes-enviar.inicial'),
      loading: t('botoes-enviar.carregando'),
    },
    translate
  );
  return (
    <ButtonBase
      className={`button-default btn-color-${classColor} ${customClasses}`}
      type="submit"
      disabled={loading}
    >
      {loading && (
        <CircularProgress size={24} className={classes.buttonProgress} />
      )}{' '}
      {loading ? translate.loading : translate.init}
    </ButtonBase>
  );
};

export default ButtonSubmit;



// WEBPACK FOOTER //
// ./src/shared/components/buttons/ButtonSubmit.tsx